import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const Step1Veterinario = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="fecha">Fecha *</Label>
          <Input
            id="fecha"
            type="date"
            value={formData.fecha}
            onChange={(e) => updateFormData('fecha', e.target.value)}
            required
            className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="horaToma">Hora de la Toma *</Label>
          <Input
            id="horaToma"
            type="time"
            value={formData.horaToma}
            onChange={(e) => updateFormData('horaToma', e.target.value)}
            required
            className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
          />
        </div>
      </div>

      <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <h3 className="text-lg font-semibold text-[#505BB3] mb-4">Datos del Médico Veterinario</h3>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="nombreVeterinario">Nombre *</Label>
            <Input
              id="nombreVeterinario"
              type="text"
              placeholder="Nombre completo del veterinario"
              value={formData.nombreVeterinario}
              onChange={(e) => updateFormData('nombreVeterinario', e.target.value)}
              required
              className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="clinica">Clínica *</Label>
            <Input
              id="clinica"
              type="text"
              placeholder="Nombre de la clínica veterinaria"
              value={formData.clinica}
              onChange={(e) => updateFormData('clinica', e.target.value)}
              required
              className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="telefonoVeterinario">Teléfono *</Label>
              <Input
                id="telefonoVeterinario"
                type="tel"
                placeholder="Teléfono de contacto"
                value={formData.telefonoVeterinario}
                onChange={(e) => updateFormData('telefonoVeterinario', e.target.value)}
                required
                className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="emailVeterinario">Email *</Label>
              <Input
                id="emailVeterinario"
                type="email"
                placeholder="correo@ejemplo.com"
                value={formData.emailVeterinario}
                onChange={(e) => updateFormData('emailVeterinario', e.target.value)}
                required
                className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1Veterinario;